import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import { login } from "api/auth";
import { setSession } from "utils/authStorage";
import { getErrorMessage } from "utils/cms";
import logo from "../../assets/logo/main_logo.webp";
import "./signin.css";

export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setError("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      setError("Enter a valid email");
      return;
    }
    if (!password || password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const res = await login(trimmedEmail, password);
      const body = res.data || {};
      const payload = body.data || {};
      const token = payload.token || body.token;
      if (body.isSuccess === false || !token) {
        setError(body.message || "Login failed");
        return;
      }
      setSession(token, payload.user?.email || trimmedEmail);
      navigate("/admin/header", { replace: true });
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark flex h-full w-full items-center justify-center bg_image_container">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-[500px] rounded-2xl border border-white/10 bg-white/5 p-5 shadow-2xl backdrop-blur-md sm:rounded-3xl sm:p-14"
      >
        <img
          src={logo}
          alt="Kodeera"
          className="mx-auto mb-3 h-auto w-[240px] max-w-full object-contain"
        />
        <p className="mb-10 text-center text-sm font-medium uppercase tracking-[0.28em] text-white/70">
          CMS Admin
        </p>
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@kodeera.com"
          id="email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Password@123"
          id="password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {error ? (
          <p className="mb-3 text-sm font-medium text-red-400">{error}</p>
        ) : null}
        <button
          type="submit"
          disabled={loading}
          className="linear mt-2 w-full rounded-xl bg-gradient-to-r from-[#4C3FE8] to-[#A855F7] py-[12px] text-base font-medium text-white transition duration-200 hover:opacity-90 disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
